'use client';

import { FC, useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import CopyRight from './CopyRight';
import { MainWrapper } from './styles';
import Instagram from '../../assets/images/svg/instagram-white.svg';
import Image from 'next/image';
import SubscribeForm from '../SubscribeForm';
import { FooterContainer } from './styles';
import { WhatsApp } from '@mui/icons-material';
import { getUISectionByName } from '../../api/content';
import { useAppSelector } from '../../hooks/reduxHooks';

const Footer: FC = () => {
  const [data, setData] = useState<any>({});
  const [address, setAddress] = useState<string>('');

  const locale = useAppSelector((d) => d.locale);

  useEffect(() => {
    getUISectionByName('?curr=EUR&filter[column]=Name&filter[value]=contactUsPage&filter[option]=11')
      .then((res) => {
        res &&
          res.data &&
          setData(res?.data[0]?.componentsGroups.filter((t: any) => t.selected === true)[0]?.components);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(() => {
    if (!data || !Array.isArray(data)) return;
    setAddress(data.find((d: any) => d.key === 'contactUsPageSubtitle1Address').localizations[0]?.value);
  }, [data]);

  return (
    <>
      <MainWrapper>
        <FooterContainer style={{ maxWidth: '100%', width: '100%', padding: '0 155px 0 100px', margin: '0' }}>
          <Box
            display='flex'
            justifyContent='space-between'
            sx={{
              flexDirection: { xs: 'column', md768: 'row' },
              padding: { xs: '60px 4px', md768: '80px 0 67px' },
              gap: '60px',
            }}
          >
            <Box display='flex' flexDirection='column' gap='30px' flex={1} maxWidth='506px'>
              <Typography
                variant='h1'
                component='div'
                style={{ color: '#FFFFFF', fontSize: '48px', lineHeight: '60px', marginBottom: '10px' }}
              >
                {locale.footer_title}
              </Typography>
              <Typography
                color='#CDCDCD'
                maxWidth='620px'
                sx={{
                  color: { xs: '#d7d7d7', md768: '#C8C8C8', lineHeight: '22px' },
                }}
                style={{ marginBottom: '2px', maxWidth: '530px' }}
              >
                {locale.footer_info}
              </Typography>
              <SubscribeForm />
            </Box>
            <Box display='flex' flexDirection='column' gap='20px' width='342px'>
              <Typography color='white' variant='h1' component='span' fontSize='48px' mb='20px' lineHeight='60px'>
                {locale.footer_stay_connected}
              </Typography>
              <Stack gap='2px'>
                <Typography
                  variant='button'
                  textTransform='uppercase'
                  color='rgba(205, 205, 205, 0.6)'
                  style={{ marginBottom: '4px' }}
                >
                  {locale.footer_contact}
                </Typography>
                <Typography className='contact-text'>
                  {' '}
                  <a href='tel:+420 739 22 10 10'>+420 739 22 10 10</a>
                </Typography>
                <Typography className='contact-text'>
                  {' '}
                  <a href='tel:+420 739 04 10 10'>+420 739 04 10 10</a>
                </Typography>
                <Typography className='contact-text'>
                  <a href='mailto:info@chrono1010.watch'>info@chrono1010.watch</a>
                </Typography>
                <Typography className='contact-text'>
                  {' '}
                  <a href='mailto:customer.support@chrono1010.watch'>customer.support@chrono1010.watch</a>
                </Typography>
              </Stack>
              <Stack gap='6px'>
                <Typography
                  variant='button'
                  style={{ textTransform: 'uppercase', color: 'rgba(205, 205, 205, 0.6)', fontSize: '16px' }}
                >
                  {locale.address}
                </Typography>
                <Stack gap='2px'>
                  <Typography className='contact-text'>{address}</Typography>
                  <Typography className='contact-text'>Prague, Czech Republic</Typography>
                </Stack>
              </Stack>
              <Box display='flex' alignItems='center' gap='20px'>
                <a href='https://www.instagram.com/chrono1010.watch/' target='_blank' rel='noopener noreferrer'>
                  <Image src={Instagram} alt='Instagram' />
                </a>
                <a
                  href='https://wa.me/4207392210100'
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label='WhatsApp'
                  title='WhatsApp'
                >
                  <WhatsApp style={{ height: '33px', color: 'white', fontSize: '27px' }} />
                </a>
              </Box>
            </Box>
          </Box>
        </FooterContainer>
      </MainWrapper>
      <CopyRight />
    </>
  );
};

export default Footer;
